var map = {
	"./11X5.svg": "8106",
	"./ELOTT_CEN.svg": "f711",
	"./FISH_CEN.svg": "b64a",
	"./K3.svg": "8b1f",
	"./LF.svg": "7897",
	"./LHC.svg": "5bdd",
	"./LIVE_CEN.svg": "be6a",
	"./LOTT_CEN.svg": "8aa8",
	"./PCB.svg": "4d2f",
	"./PK10.svg": "2c2a",
	"./SLOT_CEN.svg": "3142",
	"./SPORTS_CEN.svg": "0351",
	"./SSC.svg": "3694",
	"./VIDEO.svg": "726a",
	"./agent.svg": "431d",
	"./appDownload.svg": "78c2",
	"./arrowIcon.svg": "d35c",
	"./back.svg": "c606",
	"./feedback.svg": "a2c1",
	"./fish_icon.svg": "e327",
	"./gamenav_ELOTT.svg": "ac23",
	"./gamenav_FISH.svg": "b6de",
	"./gamenav_LIVE.svg": "7cc2",
	"./gamenav_LOTT.svg": "6d6c",
	"./gamenav_PVP.svg": "be84",
	"./gamenav_RNG.svg": "a7a1",
	"./gamenav_SPORTS.svg": "24e9",
	"./helpCenter.svg": "05e3",
	"./live.svg": "e67d",
	"./liveChat.svg": "e84b",
	"./live_icon.svg": "8cbd",
	"./longDragon.svg": "7534",
	"./lott_icon.svg": "c047",
	"./message.svg": "7501",
	"./new.svg": "20c5",
	"./noticeBoard.svg": "a3ed",
	"./promotion.svg": "e067",
	"./qq.svg": "72b5",
	"./qrAndroid.svg": "b26e",
	"./qrIos.svg": "05d8",
	"./recharge.svg": "5046",
	"./rng_icon.svg": "1e23",
	"./skype.svg": "9c5e",
	"./sms.svg": "b07b",
	"./speedTest.svg": "f753",
	"./sport_icon.svg": "3981",
	"./username.svg": "9c8c",
	"./wechat.svg": "cb6e",
	"./withdraw.svg": "fedc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "219f";